import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { User } from '../../_objects/user';
import { HttpService } from '../http.service';
import { ElectronService } from '../../electron.service';

@Injectable({
  providedIn: 'root'
})
export class MeUserOnlineService extends HttpService {

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
    private router: Router,
    private electronService: ElectronService) {
    super();
    super.setCookieService(cookieService);
    super.setHttpClient(http);
    super.setRouter(router);
  }

  // ME01 GET /api/v1/me
  getMe(): Observable<User> {
    const endpoint = super.getEndpoint('me');
    return this.http.get<User>(endpoint,
      {
        withCredentials: super.getWithCredentialsOption()
      }).pipe(map(response => response as User));
  }

  // ME02 PUT /api/v1/me/terms/agree
  putUserAgreeTerms(): Observable<User> {
    const endpoint = super.getEndpoint('me', 'terms', 'agree');

    return this.http.put<User>(endpoint, null, {
      withCredentials: super.getWithCredentialsOption()
    })
      .pipe(map(response => response as User));
  }
}
